import * as React from 'react';

const Download = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={17} height={16} viewBox="0 0 40 40" {...props}>
        <g fill="currentColor">
            <path d="M37.778 28.23a2.02 2.02 0 0 0-2.02 2.02v3.092a2.62 2.62 0 0 1-2.618 2.616H6.86a2.62 2.62 0 0 1-2.618-2.616V30.25a2.02 2.02 0 0 0-4.04 0v3.092a6.667 6.667 0 0 0 6.658 6.666h26.28a6.667 6.667 0 0 0 6.667-6.666V30.25a2.02 2.02 0 0 0-2.029-2.02" />
            <path d="M20 0a3.23 3.23 0 0 0-3.232 3.232v15.11a.417.417 0 0 1-.416.416H11.92a1.617 1.617 0 0 0-1.22 2.677l8.08 9.293a1.615 1.615 0 0 0 2.44 0l8.08-9.293a1.617 1.617 0 0 0-1.22-2.677h-4.432a.417.417 0 0 1-.416-.416V3.232A3.23 3.23 0 0 0 20 0" />
        </g>
    </svg>
);
export default Download;
